// Layout.jsx
import React, { useState, useEffect } from "react";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import { Outlet } from "react-router-dom";

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  // Desktop collapse state - persisted in localStorage
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    const saved = localStorage.getItem("sidebarCollapsed");
    return saved ? JSON.parse(saved) : false;
  });

  // Persist collapsed state
  useEffect(() => {
    localStorage.setItem("sidebarCollapsed", JSON.stringify(sidebarCollapsed));
  }, [sidebarCollapsed]);

  const toggleCollapse = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className="relative">
      {/* Pass the menu‐toggle callback */}
      <Header onMenuClick={() => setSidebarOpen(true)} />

      <div className="flex relative">
        {/* Mobile overlay - only on mobile */}
        {sidebarOpen && (
          <div
            className="fixed inset-0 z-20 bg-black bg-opacity-50 md:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}
        
        {/* Sidebar with collapse state */}
        <Sidebar 
          isOpen={sidebarOpen} 
          isCollapsed={sidebarCollapsed}
          onCollapse={toggleCollapse}
        />

        {/* Main content with dynamic margin */}
        <main 
          className={`
            flex-1 bg-gradient-to-br from-gray-50 via-slate-50 to-gray-50 
            min-h-[calc(100vh-4rem)]
            transition-all duration-300 ease-in-out
            ml-0
            mt-16
            ${sidebarCollapsed ? 'md:ml-20' : 'md:ml-64'}
          `}
        >
          <div className="w-full h-full">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
